import { Provider } from "mobx-react";
import { observer } from "mobx-react-lite";
import * as React from "react";
import {
  AsphaltPolyfill,
  ErrorModal,
  ErrorModalStoreContext,
  ToastManager,
  useErrorModalStore,
} from "src/components";
import { MIDTRANS_APP_THEME } from "src/contexts";
import { BrowserRouter as Router } from "react-router-dom";
import PassportContainer, { LivenessCallbackContainer } from "src/modules";
import { PassportAuthProvider } from "src/providers/PassportAuth.provider";
import { ThemeProvider } from "styled-components";
import AsphaltThemeProvider from "@asphalt-react/theme-provider";
import { MIDTRANS_ASPHALT_THEME } from "./constants";
import { useWindow } from "./hooks";
import { useRootStore } from "./stores/Root.store";
import { Route, Switch } from "react-router";
import { PASSPORT_ROUTES } from "./constants/routes";

export const PassportApp = observer(() => {
  const modalStore = useErrorModalStore();
  const { innerHeight } = useWindow();
  const rootStore = useRootStore();

  const styledThemeWithHeight = {
    ...MIDTRANS_APP_THEME,
    viewHeight: innerHeight + "px",
  };

  return (
    <Provider {...rootStore}>
      <AsphaltThemeProvider theme={MIDTRANS_ASPHALT_THEME}>
        <AsphaltPolyfill />
        <ThemeProvider theme={styledThemeWithHeight}>
          <ErrorModalStoreContext.Provider value={modalStore}>
            <Router>
              <Switch>
                <Route path={PASSPORT_ROUTES.oneKycCallback}>
                  <LivenessCallbackContainer />
                </Route>
                <Route>
                  <PassportAuthProvider>
                    <PassportContainer />
                  </PassportAuthProvider>
                </Route>
              </Switch>
            </Router>
            <ToastManager />
            <ErrorModal
              showModal={modalStore.show}
              content={modalStore.content}
              onClose={() => modalStore.hideAlert()}
              onClick={() => modalStore.onClick()}
            />
          </ErrorModalStoreContext.Provider>
        </ThemeProvider>
      </AsphaltThemeProvider>
    </Provider>
  );
});
